import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import './scss/main.scss';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
